import React, { useRef } from 'react';
import { Row, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioDeContratosPorTransportador({ dadosRelatorio, btnVoltar, filtros }) {
    const { setupVariavel, session } = useAuth();
    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);
    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersContratos = [
        { value: "CPF/CNPJ", objectValue: "cpfcnpj", col: "4" },
        { value: "E-MAIL", objectValue: "email", col: "8" },

        { value: "RESPONSAVEL", objectValue: "contato", col: "4" },
        { value: "FANTASIA", objectValue: "fantasia", col: "8" },

        { value: "FONE", objectValue: "fone", col: "4" },
        { value: "RAZÃO SOCIAL", objectValue: "razao", col: "8" },

        { value: "CATEGORIA", objectValue: "categoria", col: "4" },
        { value: "RAMO DE ATIVIDADE", objectValue: "ramoAtividade", col: "6" },
        { value: "STATUS", objectValue: "status", col: "2" },

        { value: "CARACTERÍSTICA", objectValue: "caracteristica", col: "4" },
        { value: "CEP", objectValue: "cep", col: "4" },
        { value: "CIDADE", objectValue: "cidade", col: "4" },

        { value: "UF", objectValue: "uf", col: "4" },
        { value: "BAIRRO", objectValue: "bairro", col: "8" },

        { value: "LOGRADOURO", objectValue: "logradouro", col: "8" },
        { value: "NUMERO", objectValue: "numero", col: "4" },

        { value: "REGIONAL", objectValue: "regional", col: "4" },
        { value: "COMPLEMENTO", objectValue: "complemento", col: "8" },

        { value: "MODALIDADE DE COLETA", objectValue: "modalidadeColeta", col: "12" },

        { value: "TRANSPORTADOR", objectValue: "transportador", col: "12" },
        { value: "FREQUÊNCIA", objectValue: "frequencia", col: "4" },
        { value: "CALENDARIO", objectValue: "calendario", col: "4" },
        { value: "SITUAÇÃO DO CONTRATO", objectValue: "situacaoContrato", col: "4" },
    ];
    //Headers para exportar csv
    const headersExport = headersContratos.map(value => {
        return { label: value.value, key: value.objectValue }
    })
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de contratos por transportador",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosRelatorio.contratos} headers={headersExport} filename="Relatorio de contratos por transportador.csv" target="_blank" ref={exportRef}></CSVLink>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}}  />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de contratos por transportador</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                        <div className='col-4'>
                            {filtros.ramoAtividadeId_selected
                                ?
                                <p><span className="fw-bold">Ramo de atividade:</span> {filtros.ramoAtividadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Ramo de atividade:</span> Todos</p>
                            }
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.transportadorId_selected
                                ?
                                <p><span className="fw-bold">Transportador:</span> {filtros.transportadorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Transportador:</span> Todos</p>
                            }
                        </div>
                        <div className='col-4'>
                            {filtros.modalidadeId_selected
                                ?
                                <p><span className="fw-bold">Modalidade:</span> {filtros.modalidadeId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Modalidade:</span> Todas</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>CONTRATOS</h5>
                    <CardRelatorio headers={headersContratos} items={dadosRelatorio.contratos} />
                </div>
            </div>
        </MainCard>
    )
}